module.exports = __webpack_public_path__ + "img/xinwen8.0bdc80ae.jpg";